<div class="mb-2">
  <textarea class="form-control  diag" [disabled]="true" rows="20">{{ info }}</textarea>
</div>